<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader :shopcart="shopcart" :shopcart_qty="shopcart_qty" :shopcart_total="shopcart_total"
			@data-updated-shopcart="handleShopcartUpdated"></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: hidden;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page='selected_page'></rosidebar>
					<el-dialog title="转账汇款" :visible.sync="dialogVisible_duigong" width="40%"
						:before-close="handleClose">
					
						<el-upload class="upload-demo" ref="upload" :action="uploadUrl" list-type="picture-card"
							:before-upload="beforeUpload" :on-remove="handleRemove" :file-list="fileList"
							:auto-upload="false" accept=".png,.jpg,.jpeg" multiple :data="{ order_id: order_id }">
							<el-button slot="trigger" size="small" type="primary">选取图片</el-button>
							<div slot="tip" class="el-upload__tip">请您转账时在附加或备注信息中填写<span
									style='color:red'>手机号码</span>,上传的转账凭证图片要完整、清晰，以便我们及时处理您的订单。图片大小在500K以内。
							</div>
						</el-upload>
						<el-button style="margin-left: 10px;" size="small" type="success"
							@click="submitUpload">确认上传</el-button>
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%;margin-top: 5%;"
								@click="handleClose">退出</el-button>
						</div>
					
					</el-dialog>			
				
				<div style="float: right;width:calc(100% - 269px);overflow: hidden;min-height:800px;background: white;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 50px;text-align: left;padding-left: 20px;">
						我的订单 <span style="color:red"></span>
					</h6>


					<el-dialog title="快递信息" :visible.sync="ExpressdialogVisible" width="40%"
						:before-close="handleClose">
						<div style="overflow: hidden;width:85%;margin:20px auto;">

							<el-timeline :reverse="'true'">
								<el-timeline-item v-for="(express, index) in express_info" :key="index"
									:timestamp="express.AcceptTime">
									{{express.AcceptStation}}
								</el-timeline-item>
							</el-timeline>
						</div>
					</el-dialog>

					<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
						style="margin-left: 20px;">
						<el-menu-item index="-1">费用审核不通过
						</el-menu-item>
						<el-menu-item index="0">费用待审核
						</el-menu-item>

						<el-menu-item index="1">待发货
						</el-menu-item>
						<el-menu-item index="2">待收货
						</el-menu-item>
						<el-menu-item index="3">已完成
						</el-menu-item>
					</el-menu>
					<div style="width: 95%;margin:20px auto;padding:0 10px;border: 2px dotted #F0F0F0;height: 50px;">

						<el-button size="small" style="float: left;margin-top: 8px;background-color: red;color:white;"
							@click="turn_to_shopcart()">购物车下单</el-button>

						<el-pagination style=";margin-top: 8px;float: right;" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-size="PageSize" background
							layout="total, prev, pager, next" :total="totalCount">
						</el-pagination>
					</div>
					<div v-if="state=='待收货'"
						style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
						<div>温馨提示：每6期（张）1包（卷），订购1份A套发货2包，订购1份B套发货1包，以此类推。</div>
						<div>例：订购2份A套，2份B套，共发货6包，有6个物流信息。</div>
					</div>
					<!-- default-expand-all -->
					<el-table :data="order_datas" tooltip-effect="dark" stripe style="width: 95%;margin:auto;"
						:expand-row-keys="expandedRows" @row-click="handleRowClick" row-key="id" default-expand-all>
						<el-table-column type="expand">
							<template slot-scope="scope">
								<el-table :data="scope.row.line_list">
									<el-table-column label="" width="100">
										<template slot-scope="scope">
											<img :src="scope.row.product_image" style="width:80px;loat:left;" />
										</template>
									</el-table-column>
									<el-table-column prop="product_name" label="产品名称"></el-table-column>
									<el-table-column prop="qty" label="数量"></el-table-column>
									<el-table-column prop="price" label="单价"></el-table-column>
									<el-table-column prop="subtotal" label="价格"></el-table-column>
									<!-- <el-table-column label="邮件信息" width="240">
										<template slot-scope="scope">
											<ul>
												<li v-for="(delivery_message,index) in scope.row.delivery_message">
													<el-button type="text"
														@click="show_delivery_message(delivery_message)">
														{{delivery_message}}
													</el-button>
												</li>

											</ul>
										</template>
									</el-table-column> -->
								</el-table>
								<div v-if="scope.row.delivery_message.length>0">
									<div style="font-size: 18px;margin: 10px;">快递单号</div>
									<div v-for="(delivery_message,index) in scope.row.delivery_message"
										style="width: 20%;float: left;border: 1px solid #ebeef5;">
										<el-button type="text" @click="show_delivery_message(delivery_message)">
											{{delivery_message}}
										</el-button>
									</div>

								</div>

								<div v-if="scope.row.state=='check_false'">
									<div style="font-size: 18px;margin: 10px;color:red">
										费用审核不通过原因：{{scope.row.reject_reason}}</div>

								</div>
								<el-button type="warning" size="small" style="float: right;margin: 10px;" v-if="scope.row.state=='check_false'"
									@click="finish_order(scope.row)">重新缴费</el-button>
									

								<el-button type="warning" size="small" style="float: right;margin: 10px;"
									v-if="scope.row.invoice_state=='draft' && scope.row.invoice_state!='none'"
									@click="turn_to_invoice(scope.row)">申请发票</el-button>

								<el-button type="warning" size="small" style="float: right;margin: 10px;"
									v-if="scope.row.invoice_state!='yes'&&scope.row.invoice_state!='draft' && scope.row.invoice_state!='none'">开票中</el-button>
								<el-button type="primary" size="small" style="float: right;margin: 10px;"
									v-if="scope.row.invoice_state=='yes'"
									@click="download_url(scope.row.invoice_download_url)">下载发票</el-button>
							</template>

						</el-table-column>
						<el-table-column prop="name" label="订单号" sortable width="140">
						</el-table-column>
						<el-table-column prop="create_date" label="时间" sortable width="180">
						</el-table-column>
						<el-table-column prop="partner_name" label="收货人" width="140">
						</el-table-column>
						<el-table-column prop="address_name" label="收件地址" width="220">
						</el-table-column>
						< <el-table-column prop="mobile" label="手机/电话" width="120">
							</el-table-column>

					</el-table>


				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import {
		baseURL
	} from "../utils/baseURL"
	
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'Demo',
		data() {
			return {
				uploadUrl: baseURL + '/ro/web_eshop/order/file/update/v1', // 文件上传的接口地址
				order_name:0,
				order_id:0,
				fileList:[],
				select_shopcart_total:0,
				can_get_pay_state: true,
				flush_pay_state: false,
				timer: '',
				order_pay_title: '订单创建成功',
				dialogVisible_duigong: false,
				loading: true,
				paying: false,
				ali_pay_img: '',
				pay_img: 'https://p2.itc.cn/images01/20211001/f2b77a3dd20f4be88cd84a9d659fa1cb.jpeg',
				payName:'转账汇款',
				
				activeIndex: '1',
				type: 'tech', //默认科技查新
				selected_page: '2-2',

				order_datas: [],
				now_select_order: {},
				state: '待发货',
				currentPage: 1,
				// 总条数，根据接口获取数据长度(注意：这里不能为空)
				totalCount: 0,
				// 个数选择器（可修改）
				// 默认每页显示的条数（可修改）
				PageSize: 12,
				expandedRows: [],
				ExpressdialogVisible: false,
				express_info: [{
					AcceptStation: '活动按期开始',
					AcceptTime: '2018-04-15'
				}, {
					AcceptStation: '通过审核',
					AcceptTime: '2018-04-13'
				}, {
					AcceptStation: '创建成功',
					AcceptTime: '2018-04-11'
				}],
				shopcart_qty: 0,
				shopcart_total: 0,
				shopcart:'',

			}
		},
		mounted() {
			var self = this
			var type = this.$route.query.type
			// debugger
			if (type != undefined) {
				this.state = '已完成'
				this.activeIndex = '2'
			}

			this.get_order_info()
			this.get_shopcart()
			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			
			
			beforeUpload(file) {
				const isLt2M = file.size / 1024 < 500;
			
				console.log(file.size)
				console.log(isLt2M)
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 500kb!');
					// return
				}
				return  isLt2M
			
			},
			submitUpload() {
				this.$loading('处理中')
				var self  = this
				var uploadFiles = this.$refs.upload.uploadFiles
				var file_data = []
				var order_id = this.order_id
				for (var i = 0; i < uploadFiles.length; i++) {
					// console.log(uploadFiles[i].name)
					var name = uploadFiles[i].name
					var file = uploadFiles[i].raw
					// debugger
				
					const reader = new FileReader();
					reader.onload = (e) => {
						var data = {
							// 'order_id': order_id,
							'data': e.target.result,
							'name':name,
						}
						file_data.push(data)
						self.file_data = file_data
							
					};
					reader.readAsDataURL(file);
				
					// debugger
				}				
				setTimeout(function() {
					var data = {
						'order_id':self.order_id,
						'file_data':JSON.stringify(self.file_data)
					}
					fetchPost('/ro/web_eshop/order/file/update/v1', data).then(response => {
						self.$message.success('上传成功')
						clearInterval(self.timer)
						setTimeout(function() {
							self.$loading().close()
							window.location.reload()
							
						},1000)
						
						
					})
				}, 1000)			
			},
			flush_pay() {
				clearInterval(this.timer)
				this.flush_pay_state = false
				this.wx_pay()
				this.ali_pay()
			},
			get_pay_state() {
				var self = this
				var data = {
					'id': this.order_id
				}
				if (!this.can_get_pay_state) {
					return
				}
				fetchPost('/ro/eshop/order/get_payment_state/v1', data).then(response => {
					console.log(response.data)
					if (response.data.result == 'success') {
						self.order_pay_title = '订单支付完成,5s后将自动跳转'
			
						clearInterval(self.timer)
						self.can_get_pay_state = false
						setTimeout(function() {
							self.turn_to_invoice()
						}, 5000)			
					}
				})
			},
			
			ali_pay() {
				// debugger
				this.ali_pay_img = baseURL + '/ro/connector/alipay/ali_pay/v1?type=eshop&order_id=' + this.order_id+'&date='+Date.now();			
			},
			wx_pay() {
				// debugger
				var data = {
					'order_id': this.order_id,
					'type': 'eshop'
				}
			
				var self = this
				setTimeout(function() {
					console.log('可以刷新了 ')
					self.flush_pay_state = true
				}, 5000)
				fetchPost('/ro/connector/wx/wx_pay_native/v1', data).then(response => {
					self.pay_img = response.data
					self.loading = false
					self.paying = true
			
					var timer = setInterval(function() {
						console.log('循环查询订单支付情况')
						self.get_pay_state()
			
					}, 1000)
					self.timer = timer
				})
			
				// this.loading = false
			},
			
			
			handlePayClose() {
				clearInterval(this.timer)
				this.dialogVisible_duigong = false
			},
			finish_order(item){
				this.order_id = item.id
				this.order_name = item.name
				// debugger
				this.select_shopcart_total = item.total_fees
				this.dialogVisible_duigong = true				
			},
			get_shopcart() {
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == '' || shopcart == null) {
					shopcart = [];
				} else {
					shopcart = JSON.parse(shopcart)
				}
				var shopcart_qty = 0
				var shopcart_total = 0
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total += parseFloat(shopcart[i].total)
				}

				this.shopcart = shopcart
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
			},

			handleShopcartUpdated(updatedData) {
				this.shopcart = parseFloat(updatedData).toFixed(2);
			},
			handleShopcartQtyUpdated(updatedData) {
				this.shopcart_qty = parseFloat(updatedData).toFixed(2);;
			},
			handleShopcartTotalUpdated(updatedData) {
				this.shopcart_total = parseFloat(updatedData).toFixed(2);;
			},

			turn_to_invoice(row) {
				// debugger
				//window.location.href = '#/user/invoice?id=' + this.order_id + '&total_fees=' + this.select_shopcart_total
				this.$router.push('/user/invoice?id=' + row.id + '&total_fees=' + row.total_fees)
			},
			download_url(row) {
				console.log(row)
				window.open(row, "_blank");
			},
			show_delivery_message(express_code) {
				var data = {
					'LogisticCode': express_code
				}
				var self = this
				fetchPost('/ro/connector/kdn/get_traces/v1', data).then(response => {
					self.ExpressdialogVisible = true
					// debugger
					// console.log(response.data.traces)
					self.express_info = response.data.Traces
					// self.get_order_info()
				})
			},
			handleRowClick(row) {
				if (this.expandedRows.includes(row.id)) {
					// 如果当前行已展开，则关闭它
					const index = this.expandedRows.indexOf(row.id);
					this.expandedRows.splice(index, 1);
				} else {
					// 否则，关闭其他行的明细，展开当前行
					this.expandedRows = [row.id];
				}
			},

			handleCurrentChange(val) {
				console.log(val)
				console.log('handleCurrentChange')
				this.currentPage = val
				this.get_order_info()
			},




			handleClose() {
				this.ExpressdialogVisible = false
				this.dialogVisible_duigong = false
				clearInterval(this.timer)
			},

			handleSelect(key, keyPath) {
				console.log(key);
				if (key == -1) {
					this.state = '费用审核不通过'
				}
				if (key == 0) {
					this.state = '费用待审核'
				}
				if (key == 1) {
					this.state = '待发货'
				}
				if (key == 2) {
					this.state = '待收货'
				}
				if (key == 3) {
					this.state = '已完成'
				}

				this.get_order_info()

			},
			turn_to_shopcart() {
				this.$router.push('/finish_order')
			},



			get_order_info() {
				var self = this
				// debugger
				var data = {
					'id': window.localStorage.getItem('eshop_user_id'),
					'state': this.state,
					'page': this.currentPage,
					'page_size': this.PageSize,
				}
				fetchGet('/ro/web_eshop/order/list/v1', data).then(function(response) {
					// debugger
					self.order_datas = response.data.list
					console.log(self.order_datas)
					self.totalCount = response.data.totalCount
					// if (self.order_datas.length > 0) {
					//       self.expandedRows.push(self.order_datas[0].id); // 将第一行的行标识符添加到展开行的数组中
					//     }
				})
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			tabClick(row, column, cell, event) {
				switch (column.label) {
					case '顺序':
						this.tabClickIndex = row.index
						this.tabClickLabel = column.label
						break
					default:
						return
				}
				console.log('tabClick', this.tabClickIndex, row.adName, row.adSort)
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				// 把每一行的索引放进row
				row.index = rowIndex
			},

		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}

	/* 	.el-checkbox.is-bordered{
		padding:6px !important;
		
		height: auto;
	}
	.el-checkbox{
		margin-right: 0px;
	}
	.el-checkbox__label{
		font-size: 12px !important;
	} */
</style>
